import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=08058440&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&lang=js"
export * from "./AdminSettings.vue?vue&type=script&lang=js"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=08058440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08058440",
  null
  
)

export default component.exports